import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/zeeno_logo.png'
import mail from '../../assets/icons/ic_mail.svg'
import lock from '../../assets/icons/ic_lock.svg'
import welcome from '../../assets/images/welcom_image.png'
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth'
import { auth, db } from '../../firebase-config'
import { collection, getDocs, query, serverTimestamp, updateDoc, where } from 'firebase/firestore'
import { useSetAtom } from 'jotai'
import { loggedInUser } from '../store/DataStore'

function Login() {
    const navigate = useNavigate();
    const [savedEmail, setSavedEmail] = useState("");
    const [savedPass, setSavedPass] = useState("");
    const [savedError, setSavedError] = useState("");
    const [isError, setIsError] = useState(false);
    const [users, setUsers] = useState([]);
    const setCurrentUser = useSetAtom(loggedInUser)

    useEffect(() => {
        document.title = "Zeeno | Login";
    }, [])

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const usersCollectionRef = collection(db, 'Companies/Zeeno_Dev/Users');
                const querySnapshot = await getDocs(usersCollectionRef);
                const usersData = [];
                querySnapshot.forEach((doc) => {
                    const userData = doc.data();
                    usersData.push(userData);
                });
                setUsers(usersData);
                console.log("list of users is: " + usersData);

            } catch (error) {
                console.error('Error fetching users: ', error);
            }
        };

        fetchUsers();
        return () => { };
    }, []);

    const refreshLastSeen = async (userEmail) => {
        if (!userEmail) {
          console.error('Invalid user email');
          return;
        }
      
        try {
          const usersCollectionRef = collection(db, 'Companies/Zeeno_Dev/Users');
          const q = query(usersCollectionRef, where("email", "==", userEmail));
          const querySnapshot = await getDocs(q);
      
          if (querySnapshot.empty) {
            console.log('No user found with the given email');
            return;
          }
          const userDoc = querySnapshot.docs[0];
          const userDocRef = userDoc.ref;
    
          await updateDoc(userDocRef, {
            lastlogin: serverTimestamp(),
            isActive: true
          });
      
          console.log('User lastLogin timestamp updated successfully');
        } catch (error) {
          console.error('Error updating user lastLogin: ', error);
        }
      };

      async function onLoginPressed(email, password) {
        // Reset error state at the beginning
        setIsError(false);
        setSavedError("");
    
        let userFound = false;
    
        users.forEach(item => {
            console.log("These are the mails in firebase: " + item.email);
            const normalizedEmail = email.trim().toLowerCase();
            if (item.email === normalizedEmail) {
                userFound = true;
                console.log("This email is correct and in firebase: " + item.email);
                signInWithEmailAndPassword(auth, normalizedEmail, password)
                    .then((user) => {
                        refreshLastSeen(item.email);
                        setCurrentUser(item);
                        setIsError(false);
                        if(normalizedEmail !== null && password !== null){
                            navigate("/home");
                        }
                        
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        setIsError(true);
                        if (errorCode === "auth/user-not-found") {
                            setSavedError("Please enter a valid user");
                        }
                        else if(errorCode === "auth/wrong-password") {
                            setSavedError("Please enter a valid password");
                        }
                        console.log('error', errorCode);
                    });
                return;
            }
        });
    
        if (!userFound) {
            setIsError(true);
            setSavedError("Please enter a valid user");
        }
    }

    const onForgotPasswordPressed = async (email) => {
        if (!email) {
            setSavedError("Please enter your email address");
            setIsError(true);
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            setSavedError("Password reset email sent successfully");
            setIsError(false);
        } catch (error) {
            setSavedError("Error sending password reset email");
            setIsError(true);
            console.error('Error sending password reset email: ', error);
        }
    }

    return (
        <main className='min-h-screen w-full overflow-x-hidden bg-white px-4 py-6 sm:px-6 lg:px-8'>
            <div className='mx-auto flex min-h-[calc(100vh-48px)] w-full max-w-[1500px] flex-col items-center justify-center gap-8 lg:flex-row lg:gap-[clamp(3rem,5vw,8rem)]'>
                <section className='flex w-full max-w-[480px] flex-col items-center rounded-3xl bg-[#3C5BD2] px-6 py-8 sm:px-10 sm:py-10 lg:min-h-[clamp(550px,64vh,890px)] lg:w-[clamp(380px,26vw,480px)] lg:px-[clamp(2.5rem,2.6vw,3rem)]'>
                    <img src={logo} alt="Zeeno" className='h-11 lg:h-[clamp(2.75rem,3.2vw,3.5rem)]' />
                    <h1 className='mt-10 font-heebo text-2xl font-medium text-white sm:text-3xl lg:mt-[clamp(2.5rem,8vh,7rem)] lg:text-[clamp(1.25rem,1.55vw,1.875rem)]'>Log In</h1>
                    <p className='mt-1 text-center font-heebo text-base font-light text-white sm:text-lg 2xl:text-xl'>Enter your email & password</p>

                    <div className='mt-8 flex w-full flex-row items-center rounded-xl bg-[#9EADE9] px-4 py-3 lg:mt-[clamp(1.5rem,2.2vw,2rem)] lg:py-[clamp(0.25rem,0.6vw,0.5rem)]'>
                        <img src={mail} alt="" className='h-5 shrink-0 sm:h-6' />
                        <input
                            onChange={(e) => setSavedEmail(e.target.value)}
                            placeholder='Email'
                            autoComplete='email'
                            className='ml-4 min-w-0 flex-1 bg-transparent font-heebo text-base font-light text-[#152FF5] outline-none placeholder:text-[#152FF5] sm:text-lg 2xl:text-xl'
                        />
                    </div>

                    <div className='mt-4 flex w-full flex-row items-center rounded-xl bg-[#9EADE9] px-4 py-3 lg:mt-[clamp(1.5rem,2.4vw,2.25rem)] lg:py-[clamp(0.25rem,0.6vw,0.5rem)]'>
                        <img src={lock} alt="" className='h-5 shrink-0 sm:h-6' />
                        <input
                            onChange={(e) => setSavedPass(e.target.value)}
                            type='password'
                            placeholder='Password'
                            autoComplete='current-password'
                            className='ml-4 min-w-0 flex-1 bg-transparent font-heebo text-base font-light text-[#152FF5] outline-none placeholder:text-[#152FF5] sm:text-lg 2xl:text-xl'
                        />
                    </div>

                    <p className={`mt-3 min-h-[28px] w-full font-heebo text-base font-light sm:text-lg ${isError ? 'text-red-200' : 'text-white'}`}>{savedError}</p>

                    <button
                        type='button'
                        className='mt-5 w-full cursor-pointer bg-transparent text-right font-heebo text-base font-light text-white underline decoration-1 underline-offset-8 sm:text-lg 2xl:text-xl'
                        onClick={() => onForgotPasswordPressed(savedEmail)}
                    >
                        Forgot Password
                    </button>

                    <button
                        type='button'
                        className='mt-10 w-full cursor-pointer rounded-2xl bg-[#152FF5] p-3 text-center font-heebo text-base font-normal text-white transition ease-in-out delay-75 hover:bg-white hover:text-[#152FF5] sm:text-lg lg:mt-[clamp(4rem,5vw,5rem)] 2xl:text-xl'
                        onClick={() => onLoginPressed(savedEmail, savedPass)}
                    >
                        Log In
                    </button>

                    <button
                        type='button'
                        className='mt-8 cursor-pointer bg-transparent font-heebo text-base font-light text-white sm:text-lg lg:mt-auto 2xl:text-xl'
                    >
                        Need Help? Contact Us
                    </button>
                </section>

                <div className='hidden min-w-0 flex-1 justify-center lg:flex'>
                    <img src={welcome} alt="welcome" className='w-full max-w-[clamp(620px,56vw,980px)] object-contain lg:max-h-[clamp(500px,58vh,760px)]' />
                </div>
            </div>
        </main>
    )
}

export default Login
